import React, { useState, useEffect } from 'react';
import AddToCart from '@hpstellar/pdp/AddToCart/AddToCart.js';

import AddOnPrice from '../../../product/components/product-configurations/addon-price';
import withPageComponents from '../../../page/components/with-page-components';
import { withAddToCart } from '../../../product/components/purchase-button-container';
import IntraDayDeals from '../../../product/components/deals';
import { PriceContainer } from '../../../product/components/product-price/with-product-price';

const StickyMobileCart = ({ price, onAdd, addText, customizeText, customizeUrl, outOfStock, offset = 0 }) => {
    const stickyStyle = {
        position: 'fixed',
        bottom: offset,
        left: 0,
        width: '100%',
        zIndex: 1035,
    };

    const [isSticky, setIsSticky] = useState(false);
    let lastKnownScrollPosition = 0;
    let ticking = false;
    const showStickyHeader = () => {
        lastKnownScrollPosition = window.scrollY + window.innerHeight;
        if (!ticking) {
            window.requestAnimationFrame(() => {
                try {
                    let cartSection = document.getElementById('addtocart');
                    if (cartSection) {
                        let elTop = cartSection.offsetTop;
                        let elHeight = cartSection.offsetHeight;
                        let elBottom = elTop + elHeight + window.innerHeight;
                        setIsSticky(lastKnownScrollPosition > elBottom || lastKnownScrollPosition < elTop);
                    } else {
                        setIsSticky(true);
                    }
                    ticking = false;
                } catch (e) {}
            });
            ticking = true;
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', showStickyHeader);
        return () => {
            window.removeEventListener('scroll', showStickyHeader);
        };
    }, []);

    return isSticky ? (
        <div style={stickyStyle}>
            <AddToCart
                price={price}
                onAdd={onAdd}
                addText={addText}
                customizeUrl={customizeUrl}
                customizeText={customizeText}
                addBtnDisabled={outOfStock}
            />
        </div>
    ) : null;
};

const getCartProps = (totalPrice, product, dealProps) => {
    const { isActive, productDeals } = dealProps;
    const deal = isActive ? productDeals.activeDeal : null;
    const { regularPrice, salePrice, ctaText: addText, customizeText, ctoLink, isOOS, productType } = totalPrice;
    const { isComingSoon } = product;

    return {
        price: {
            currencySymbol: '$',
            regularPrice,
            salePrice: deal ? deal.dealPrice * 1 : salePrice !== '0' ? salePrice : undefined,
            productType,
        },
        customizeText,
        ctoLink,
        isOOS: isComingSoon ? false : isOOS,
        addText: isComingSoon ? 'Coming soon' : addText,
    };
};

/***
 * Component determines when to render sticky add to cart on mobile devices
 */
const mobileAddToCart = ({ product, addToCart, addCTOToCart, device, offset = 0 }) => {
    if (product && device === 'mobile') {
        return (
            <IntraDayDeals itemId={product.itemId}>
                {dealProps => (
                    <PriceContainer products={[product]}>
                        {({ prices }) => {
                            const price = prices[product.sku] || {};
                            return (
                                <AddOnPrice sku={product.sku} price={price}>
                                    {({ totalPrice }) => {
                                        const { price, customizeText, ctoLink, isOOS, addText } = getCartProps(
                                            totalPrice,
                                            product,
                                            dealProps
                                        );
                                        return (
                                            <StickyMobileCart
                                                price={price}
                                                onAdd={() => {
                                                    if (product.prdClass === 'CTO') {
                                                        addCTOToCart(product, 1);
                                                    } else {
                                                        //TODO: temp fix to trigger xsell modal
                                                        let mainBtn = document.getElementById('pdpAddToCartBtn');
                                                        if (mainBtn) {
                                                            mainBtn.click();
                                                        } else {
                                                            addToCart(product, 1);
                                                        }
                                                    }
                                                }}
                                                customizeText={customizeText}
                                                customizeUrl={ctoLink}
                                                outOfStock={isOOS}
                                                addText={addText}
                                                offset={offset}
                                            />
                                        );
                                    }}
                                </AddOnPrice>
                            );
                        }}
                    </PriceContainer>
                )}
            </IntraDayDeals>
        );
    }
    return null;
};

export default withAddToCart(withPageComponents(mobileAddToCart, { components: ['product'], device: true }));
